<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import ProductGridTile from '../../product-listing-search/components/productGridTile.svelte';
  import { setRMNContext } from '../services/banner-utils';
  import RMNProductCard from './RMNProductCard.svelte';

  export let data;
  const { encodedContextPath = 'en-sa', pageId } = getAppConfig();
  function handleBannerClick() {
    setRMNContext({
      banner_type: pageId === 'homepage' ? 'Editorial Module' : 'Shoppable ad',
      source_name: window['ACC']?.utils?.getSourceNameForCurrentPage(),
    });
    if (data?.adId) {
      window.ACC.miraklads.registerClickAsync(data.adId);
    }
    const url = new URL(`${encodedContextPath}${data?.urlEn}`, window.location.origin);
    url.searchParams.set('rmnSource', 'true');

    window.location.href = url.toString();
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="link" on:click={handleBannerClick}>
  {#if pageId === 'productList' || pageId === 'search'}
    <RMNProductCard
      {data}
      options={{
        desktopImageWidth: 150,
        desktopImageHeight: 150,
        mobileImageWidth: 60,
        mobileImageHeight: 60,
        desktopTileWidth: 181,
        mobileTileWidth: 120,
      }}
    />
  {:else}
    <div>
      <ProductGridTile
        product={data}
        options={{ mobileTileWidth: 200, desktopTileWidth: 238 }}
        productCardViewType="grid-view"
        productIndex={0}
        isComparedChecked={false}
      />
    </div>
  {/if}
</div>

<style lang="scss">
  @import '../../../common/styles/vars.scss';
  .link {
    cursor: pointer;
    height: 100%;
    div {
      height: 100%;
    }
    :global {
      .product-tile-card-container {
        @include desktop-max-width {
          max-width: 200px !important;
        }
        .bottom-tags-section {
          min-height: 24px;
        }
      }
    }
  }
</style>
